import { updateDiagramShowNodes, getDiagramShowNodes } from '@process-advisor/process-miner/processMiner/processMiner';

export type ShowNodesProps = {
    start?: boolean;
    end?: boolean;
}

export const changeShowNodes = ({ start, end }: ShowNodesProps) =>
    updateDiagramShowNodes({ start, end });

export const getShowNodes = (): ShowNodesProps => getDiagramShowNodes();
